<div class="special-chart-column-comparation" fxLayout="column">
    <div fxLayout="column">
        <app-highcharts-render
            style="height: 100%"
            [options]="options"
            [visualization]="visualization"
            [series]="series"
            [points]="points"
            [company]="company"
        ></app-highcharts-render>
    </div>
</div>
